<template>
  <el-dialog
      :visible.sync="visible"
      title="选择订单产品"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1460px"
  >
    <el-form
        :inline="true"
        :model="queryForm"
        @keyup.enter.native="$refs.table.reload()"
        ref="queryForm"
        class="query-form"
        label-width="80px"
    >
      <el-form-item label="品番号：">
        <el-input v-model="queryForm.productCode" size="mini" clearable type="text"
                  placeholder="请输入品番号"></el-input>
      </el-form-item>
      <el-form-item label="SKU：">
        <el-input v-model="queryForm.skuCode" size="mini" clearable type="text"
                  placeholder="请输入SKU"></el-input>
      </el-form-item>
      <el-form-item label="品名：">
        <el-input v-model="queryForm.productName" size="mini" clearable type="text"
                  placeholder="请输入品名"></el-input>
      </el-form-item>
      <el-form-item label="颜色：">
        <el-input v-model="queryForm.color" size="mini" clearable type="text"
                  placeholder="请输入颜色"></el-input>
      </el-form-item>
      <el-form-item label="规格：">
        <el-input v-model="queryForm.size" size="mini" clearable type="text"
                  placeholder="请输入规格"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="$refs.table.reload()" size="mini">查询</el-button>
      </el-form-item>
    </el-form>
    <SweetTable :is-page="false" url="/erp/order/detail/list" :selection="true" ref="table" :query-form="queryForm"
                :height="500">
      <el-table-column label="订单编号" prop="orderCode" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="品番号" prop="product.code" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="SKU" prop="product.skuCode" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="品名" align="center" prop="product.name" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="中文品名" align="center" prop="product.nameZh" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          label="颜色"
          prop="product.color"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="规格"
          prop="product.size"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="单位"
          prop="product.unit"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
    </SweetTable>
    <template slot="footer">
      <el-button type="primary" size="mini" @click="doSubmit">确定选择</el-button>
      <el-button size="mini" @click="visible=false">取消</el-button>
    </template>
  </el-dialog>
</template>

<script>
// 订单选择明细弹窗,必须传入orderId
export default {
  name: 'SelOrderDetailDialog',
  data () {
    return {
      visible: false,
      queryForm: {
        orderId: undefined,
        productCode: undefined,
        skuCode: undefined,
        productName: undefined,
        color: undefined,
        size: undefined
      }
    }
  },
  watch: {
    'queryForm.orderId': {
      handler: function (newVal) {
        if (!newVal) {
          return
        }
        this.$nextTick(() => {
          this.$refs.table.reload()
        })
      },
      immediate: true
    }
  },
  methods: {
    init (orderId) {
      this.queryForm.orderId = orderId
      this.visible = true
    },
    doSubmit () {
      this.$emit('selected', this.$refs.table.dataListSelections)
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
